import { useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const cookieyes = useScript({"key":"cookieyes","src":"https://cdn-cookieyes.com/client_data/f435af8ccb354480e617c50e/script.js","id":"cookieyes"}, { use: () => ({ cookieyes: window.cookieyes }) })
    return { provide: { $scripts: { cookieyes } } }
  }
})